export default "__VITE_ASSET__BrPvgz1j__"